export type Step = 1 | 2 | 3 | 4 | 5;

export const STEP_SELECT_A_HOUSE : Step = 1;
export const STEP_AVAILABILITY : Step = 2;
export const STEP_SUMMARY : Step = 3;
export const STEP_PERSONAL_DETAILS : Step = 4;
export const STEP_THANK_YOU : Step = 5;

export function showStepWhenCurrentIs( step: Step, currentStep: Step ): boolean {
	if ( currentStep === STEP_THANK_YOU && currentStep !== step ) {
		// On the THANK_YOU step we hide all other steps.
		return false;
	}

	if ( step <= currentStep ) {
		// 1. Always show a step when it is the current step.
		// 2. Keep a step visible when a visitor goes to the next step.
		return true;
	}

	return false;
}

export function advanceStep( step: Step ): Step {
	switch ( step ) {
		case STEP_SELECT_A_HOUSE:
			return STEP_AVAILABILITY;

		case STEP_AVAILABILITY:
			return STEP_SUMMARY;

		case STEP_SUMMARY:
			return STEP_PERSONAL_DETAILS;

		case STEP_PERSONAL_DETAILS:
			return STEP_THANK_YOU;

		case STEP_THANK_YOU:
			return STEP_THANK_YOU;

		default:
			break;
	}

	throw new Error( 'invariant : unknown step passed to "advanceStep"' );
}

export function stepId( step: Step ): string {
	switch ( step ) {
		case STEP_SELECT_A_HOUSE:
			return 'select-a-house';

		case STEP_AVAILABILITY:
			return 'availability';

		case STEP_SUMMARY:
			return 'summary';

		case STEP_PERSONAL_DETAILS:
			return 'personal-details';

		case STEP_THANK_YOU:
			return 'thank-you';

		default:
			break;
	}

	throw new Error( 'invariant : unknown step passed to "stepId"' );
}


export function scrollStepIntoView( step: Step ) : void {
	const stepElement = document.getElementById( stepId( step ) );
	if ( stepElement ) {
		window.location.hash = stepId( step );
	}
}
